/* eslint-disable */
import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { UA, WebSocketInterface } from 'jssip';
import { DTMF_TRANSPORT } from 'jssip/lib/Constants';
import { RTCSession } from 'jssip/lib/RTCSession';
import { BehaviorSubject, Observable } from 'rxjs';
import { API_URL, Core_URL } from '../../auth/config/constants';
import { CallTypes, DialTypes, callStates } from '../models/usm-objects';
import {
  Contact,
  CustomerInfo,
} from '../modules/agent-call-view/models/agent-call-model';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  public webAgentEvent = new EventEmitter<WebAgentEventInfo>();
  public usmEvent = new EventEmitter<USMEventInfo>();
  agentSocket!: WebSocketInterface;
  sipAgent!: SipAgent;
  userAgent!: UA | null;
  rtcSession!: RTCSession | null;
  isLogout: boolean = false;

  callState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  holdState: boolean = false;
  holdStateEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  recordingState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  recordingPauseState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  transferStateEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  transferState: boolean = false;
  conferenceState: boolean = false;
  switchPortalState: boolean = false;
  conferenceStateEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  preConferenceStateEvent: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  muteState: boolean = false;
  muteStateEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  activityStateEvent: BehaviorSubject<callStates> =
    new BehaviorSubject<callStates>(callStates.AVAILABLE);
  activityState: callStates = callStates.AVAILABLE;
  dndStatesEvent: BehaviorSubject<string> = new BehaviorSubject<string>(
    'Active'
  );
  dndState: string = 'Active';
  readyState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isSipRegisteredState: boolean = false;
  isSipRegisteredStateEvent: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  isUSMLogged: boolean = false;
  isUSMLoggedInEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  handleRegistration: EventEmitter<boolean> = new EventEmitter<boolean>();
  handleMessage: EventEmitter<string> = new EventEmitter<string>();
  dialTypeEvent: BehaviorSubject<DialTypes> = new BehaviorSubject<DialTypes>(
    DialTypes.PREDICTIVE
  );
  dialType: DialTypes = DialTypes.DEFAULT;
  callTypeEvent: BehaviorSubject<CallTypes> = new BehaviorSubject<CallTypes>(
    CallTypes.DEFAULT
  );
  callType: CallTypes = CallTypes.DEFAULT;
  callEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  postCallEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  dialEvent: EventEmitter<Contact> = new EventEmitter<Contact>();
  callDuration: number = 0;
  callDurationEvent: EventEmitter<string> = new EventEmitter<string>();
  callMinimized: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  manualCall: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  actionProgress: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  micSource?: MediaStreamAudioSourceNode;
  micGainNode?: GainNode;
  destination!: MediaStreamAudioDestinationNode;
  audioContext!: AudioContext;

  dndAttributes = {
    selectedspanName: 'check_circle',
    selectedcssClass: 'active',
    selectedspanClass: 'material-icons',
  };
  beepSound: HTMLAudioElement = new Audio('assets/outgoing.mp3');
  windowObjectReference: Window | null = null;

  constructor(private readonly http: HttpClient) {}
  updateAgentPassword(
    password: string,
    oldPawword: string
  ): Observable<string> {
    return this.http.post<string>(
      `${API_URL.UPDATE_AGENT_PASSWORD}?oldPassword=${oldPawword}&newPassword=${password}`,
      ''
    );
  }
  setPreferance(state: string) {
    return this.http.post(
      API_URL.UPDATE_USER_PREF + '?userLoginPreference=' + state,
      {}
    );
  }
  setLoginState() {
    this.isLogout = false;
  }
  logOff() {
    this.isLogout = true;
    this.stopSipConnection();
  }
  setCallType(callType: CallTypes) {
    this.callType = callType;
    this.callTypeEvent.next(callType);
  }
  setDialType(dialType: DialTypes) {
    this?.dialTypeEvent?.next(dialType);
    this.dialType = dialType;
  }
  setMuteState(muteState: boolean) {
    this.muteState = muteState;
    this.muteStateEvent.next(muteState);
  }

  setDnD(dndState: string) {
    this?.dndStatesEvent?.next(dndState);
    this.dndState = dndState;
  }
  setActivityState(state: callStates) {
    this.activityState = state;
    this.activityStateEvent.next(state);
  }
  setSipRegisteredState(state: boolean) {
    this.isSipRegisteredState = state;
    this.isSipRegisteredStateEvent.next(state);
  }
  setUSMState(state: boolean) {
    this.isUSMLogged = state;
    this.isUSMLoggedInEvent.next(state);
  }
  setCallDuration(callDuration: number) {
    this.callDuration = callDuration;
    this.callDurationEvent.emit(this.formatTime(callDuration));
  }
  setHoldState(holdState: boolean) {
    this.holdState = holdState;
    this.holdStateEvent.next(holdState);
  }
  getCallDuration() {
    return this.formatTime(this.callDuration);
  }
  formatTime(seconds: number) {
    const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hours}:${minutes}:${secs}`;
  }
  stopSipConnection() {
    if (this.rtcSession && this.rtcSession.status.valueOf() !== 8) {
      this.rtcSession.terminate(); // Terminate the call session
    }
    this.userAgent?.stop();
    this.agentSocket?.disconnect();
    this.rtcSession = null;
    this.userAgent = null;
    this.setSipRegisteredState(false);
  }
  postCallReset() {
    this.transferState = false;
    this.conferenceState = false;
    this.setHoldState(false);
    this.setCallDuration(0);
    this.setDialType(DialTypes.DEFAULT);
    this.setCallType(CallTypes.DEFAULT);
    
    this.callState.next(false);
    this.recordingState.next(false);
    this.recordingPauseState.next(false);
    this.transferStateEvent.next(false);
    this.conferenceStateEvent.next(false);
    this.preConferenceStateEvent.next(false);
    this.muteStateEvent.next(false);
    this.callMinimized.emit(false);
    this.manualCall.next(false);
    // this.callState = new BehaviorSubject<boolean>(false);
    // this.recordingState = new BehaviorSubject<boolean>(false);
    // this.recordingPauseState = new BehaviorSubject<boolean>(false);
    // this.transferStateEvent = new BehaviorSubject<boolean>(false);
    // this.conferenceStateEvent = new BehaviorSubject<boolean>(false);
    // this.preConferenceStateEvent = new BehaviorSubject<boolean>(false);
    // this.muteStateEvent = new BehaviorSubject<boolean>(false);
    // this.callMinimized = new EventEmitter<boolean>(false);
    // this.manualCall = new BehaviorSubject<boolean>(false);
  }
  reset() {
    this.setCallDuration(0);
    this.setHoldState(false);
    this.transferState = false;
    this.conferenceState = false;
    this.setActivityState(callStates.AVAILABLE);
    this.setDnD('Active');
    this.setDialType(DialTypes.DEFAULT);
    this.setCallType(CallTypes.DEFAULT);
    this.setUSMState(false);
    this.callState = new BehaviorSubject<boolean>(false);
    this.recordingState = new BehaviorSubject<boolean>(false);
    this.recordingPauseState = new BehaviorSubject<boolean>(false);
    this.transferStateEvent = new BehaviorSubject<boolean>(false);
    this.conferenceStateEvent = new BehaviorSubject<boolean>(false);
    this.preConferenceStateEvent = new BehaviorSubject<boolean>(false);
    this.muteStateEvent = new BehaviorSubject<boolean>(false);
    this.callMinimized = new EventEmitter<boolean>(false);
    this.manualCall = new BehaviorSubject<boolean>(false);
    this.readyState = new BehaviorSubject<boolean>(false);
    this.handleRegistration = new EventEmitter<boolean>();
    this.dndAttributes = {
      selectedspanName: 'check_circle',
      selectedcssClass: 'active',
      selectedspanClass: 'material-icons',
    };
  }
  getCustomerInfo(
    phoneNumber: string,
    contactId: string
  ): Observable<CustomerInfo> {
    return this.http.post<CustomerInfo>(
      `${Core_URL.GET_AGENT_CUSTOMER_INFO(phoneNumber, contactId)}`,
      {}
    );
  }
  sendDTMF(no: string) {
    this.rtcSession?.sendDTMF(no, {
      transportType: DTMF_TRANSPORT.RFC2833,
    });
  }

  convertToTimeFormat(timeString: string): string {
    // Split the input string by ':', and pad with zeros if necessary
    const [hours = '0', minutes = '0', seconds = '0'] = (
      timeString ?? ''
    ).split(':');

    // Convert to integers to remove leading zeros
    const formattedHours = parseInt(hours, 10);
    const formattedMinutes = parseInt(minutes, 10);
    const formattedSeconds = parseInt(seconds, 10);

    // Build the output string based on the available parts
    let result = `${formattedHours}h`;
    if (timeString?.includes(':')) result += `:${formattedMinutes}m`;
    if (timeString?.split(':').length === 3) result += `:${formattedSeconds}s`;

    return result;
  }
  muteAudio() {
    if (!this.micGainNode) {
      return;
    }
    this.micGainNode.gain.value = 0;
  }
  unmuteAudio() {
    if (!this.micGainNode) {
      return;
    }
    this.micGainNode.gain.value = 1;
  }
  mute() {
    // this.rtcSession?.mute();
    const localStreams = this?.rtcSession?.connection?.getSenders();
    // Mute the audio tracks
    localStreams?.forEach(sender => {
      if (sender.track && sender.track.kind === 'audio') {
        sender.track.enabled = false; // Disable audio track
      }
    });
  }
  unmute() {
    // Get the local media streams (usually 1 stream with audio + video)
    // this.rtcSession?.unmute();
    const localStreams = this.rtcSession?.connection?.getSenders();
    console.log(localStreams);
    // Unmute the audio tracks
    localStreams?.forEach(sender => {
      if (sender.track && sender.track.kind === 'audio') {
        sender.track.enabled = true; // Enable audio track
      }
    });
  }
  disposeCallObjects() {
    if (this.micSource?.mediaStream) {
      this.micSource.mediaStream.getTracks()?.forEach(track => track?.stop());
    }
    this.micSource?.disconnect();
    this.micSource=undefined;
    this.micGainNode?.disconnect();
    this.destination?.disconnect();
    this.audioContext?.close();
  }
}

export interface SipAgent {
  uri: string;
  authorization_user: string;
  password: string;
  display_name: string;
  register?: boolean;
}
export interface WebAgentEventInfo {
  eventName: WebAgentEvent;
  details: Record<string, any>;
}
export interface USMEventInfo {
  eventName: USMEvent;
  details: Record<string, any>;
}

export enum WebAgentEvent {
  INIT = 'INIT',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  REGISTER_AGENT = 'REGISTER_AGENT',
  REGISTER_USM = 'REGISTER_USM',
  SET_AGENT_INFO = 'SetAgentInfo',
}
export enum USMEvent {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  REGISTER = 'REGISTER',
  PING = 'PING',
  PONG = 'PONG',
}
